import moment from "moment";

export function setItemWithExpireTime(name, value, time) {
  localStorage.setItem(name, JSON.stringify({ value, time: time.format() }));
}

export function getItemWithExpireTime(name) {
  let obj;

  try {
    obj = JSON.parse(localStorage.getItem(name));
  } catch (e) {
    return null;
  }

  if (obj && moment(obj.time).isAfter(moment())) {
    return obj.value;
  }

  return null;
}

export class DateRangeStorage {
  constructor(name) {
    this.dateFromName = `${name}dateFrom`;
    this.dateToName = `${name}dateTo`;
  }

  set(dateFrom, dateTo) {
    const expireTime = moment().add(1, "days").startOf("day");

    setItemWithExpireTime(this.dateFromName, dateFrom.format(), expireTime);
    setItemWithExpireTime(this.dateToName, dateTo.format(), expireTime);
  }

  get() {
    let dateFrom = getItemWithExpireTime(this.dateFromName);
    let dateTo = getItemWithExpireTime(this.dateToName);

    if (!dateFrom) {
      dateFrom = moment().subtract(30, "days");
    } else {
      dateFrom = moment(dateFrom);
    }

    if (!dateTo) {
      dateTo = moment();
    } else {
      dateTo = moment(dateTo);
    }

    return {
      dateFrom,
      dateTo
    };
  }
}

export const campaignsDateRangeStorage = new DateRangeStorage("campaigns");
export const widgetDateRangeStorage = new DateRangeStorage("widget");
export const teaserListDateRangeStorage = new DateRangeStorage("teaser");
export const overviewDateRangeStorage = new DateRangeStorage("overview");
export const paymentsDateRangeStorage = new DateRangeStorage("payments");
export const wmPaymentsDateRangeStorage = new DateRangeStorage("wmPayments");
